import { useState, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { Videos } from './'
import { fetchDataFromAPI } from '../utilities/fetchDataFromAPI'
import { useParams } from 'react-router-dom'

const SearchFeed = () => {

  const [ videos, setVideos ] = useState([])
  const { searchTerm } = useParams()

  useEffect(() => {
     fetchDataFromAPI(`search?part=snippet&q=${searchTerm}`).then((data) => {setVideos(data.items)})
  }, [searchTerm]);


  return (
    <Box p={2} sx={{ overflowY: 'auto', flex: 2, height: '90vh' }}>
        <Typography variant="h4" fontWeight='bold' mb={2} sx={{ color: 'white' }}>
          Search results for: <span style={{ color: '#F31503' }}>
            {searchTerm}
          </span> videos
        </Typography>

        <Videos videos={videos} />
    </Box>
  )
}

export default SearchFeed